export default __webpack_public_path__ + "media/images/check-checked-225dfe29259c9302699bdc13e2dc7936.png";